const projectData = [
    {
        name: "Gripe Support",
        technology: ["Javascript","AJAX", "REST API", "Sequelize", "Handlebars", "Express", "Node", "PaperCSS"],
        description: "Gripe support was designed as a space where one could gripe or support other user's anonymously. Visitors can create an account that will allow them to make posts (categorized as a gripe or an encouragement). Additionally, user's can 'hug' and comment on posts.",
        image: "heart",
        website: "https://infinite-bayou-42393.herokuapp.com/",
        github: "https://github.com/wsbousman/Gripe-Support"
    },
    {
        name: "Destressing Homepage",
        technology: ["Javascript", "AJAX","REST API","HTML5", "CSS", "Tailwind CSS"],
        description: "The Destressing Home Page is a responsive webpage that is intended to be visited by a user who needs to take a small break and unwind. Upon arrival to the webpage, the user is greeted with a dynamic time-based welcome message and color theme. The website allows you to view gifs, artwork, quotes, and jokes. The content for the gifs, artwork, and quotes is normally delivered at random but the user can choose to search for specific tags if they would like. Additionally, the user can create ambient sound mixes (and save presets to localStorage) to listen to while they have the page open",
        image: "music",
        website: "https://ashispatel.github.io/Project-1-DS-Homepage/",
        github: "https://github.com/AshisPatel/Project-1-DS-Homepage"
    },
    {
        name: "Tech Blog",
        technology: ["Javascript","AJAX","REST API","Sequelize", "Handlebars", "Express", "Node", "SCSS", "Bootstrap"],
        description: "Tech Blog is a simple website that users can visit and create an account that will allow them to make posts, edit their posts, view other user's posts, and comment on both their own and other user's posts. This is all made possible using the Model-View-Controller scheme. ",
        image: "sticky-note",
        website: "https://sheltered-ridge-15649.herokuapp.com/",
        github: "https://github.com/AshisPatel/Tech-Blog"
    },
    {
        name: "Pizza Hunt",
        technology: ["Javascript","AJAX","REST API","MongoDB", "Mongoose", "Express", "Node"],
        description: "Pizza Hunt is a web application where visitors can create and edit pizzas, comment on pizzas, and make replies to those comments.",
        image: "pizza-slice",
        website: "https://blooming-woodland-94327.herokuapp.com/",
        github: "https://github.com/AshisPatel/pizza-hunt"
    },
    {
        name: "Budget Tracker",
        technology: ["Javascript","AJAX","MongoDB", "REST API","Mongoose", "Express", "Node", "IndexedDB", "PWA"],
        description: "Budget Tracker is a simple PWA that one can use to track their budget by adding deposits / widhdrawls. Offline usage is maintained utilizing a service worker to create cached files and indexedDB.",
        image: "dollar-sign",
        website: "https://enigmatic-retreat-32803.herokuapp.com/",
        github: "https://github.com/AshisPatel/Budget-Tracker-PWA"
    },
   
    {
        name: "Weather Dashboard",
        technology: ["Javascript","AJAX", "REST API","HTML5", "CSS"],
        description: "The Weather Dashboard is a simple interface that displays the current weather and 5-day future forecast for a city utilizing OpenWeather's Geocoding and One Call API. The city can be searched via text-input or selected from a list of past searches on the local machine.",
        image: "cloud",
        website: "https://ashispatel.github.io/Weather-Dashboard-Week-6-Challenge/",
        github: "https://github.com/AshisPatel/Weather-Dashboard-Week-6-Challenge"
    }
];

export default projectData; 